export class PasswordChangeRequest {
    userID: string = "";
    existingPassword: string = "";
    newPassword: string = "";
    repeatPassword: string = "";
}